export enum PositivePayType {
    Check = 'Check exceptions',
    Ach = 'ACH exceptions',
    AchFilters = 'ACH exceptions filter rules',
}
